import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import cmsMenusService from "./cmsMenusService";

export const getMenus = createAsyncThunk(
  "cmsMenus/get-menus",
  async (params, thunkAPI) => {
    try {
      return await cmsMenusService.getMenus(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createMenu = createAsyncThunk(
  "cmsMenus/create-menu",
  async (menuData, thunkAPI) => {
    try {
      return await cmsMenusService.createMenu(menuData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAMenu = createAsyncThunk(
  "cmsMenus/get-a-menu",
  async (id, thunkAPI) => {
    try {
      return await cmsMenusService.getMenu(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAMenu = createAsyncThunk(
  "cmsMenus/update-menu",
  async ({ id, menuData }, thunkAPI) => {
    try {
      return await cmsMenusService.updateMenu(id, menuData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAMenu = createAsyncThunk(
  "cmsMenus/delete-menu",
  async (id, thunkAPI) => {
    try {
      return await cmsMenusService.deleteMenu(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  menus: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const cmsMenusSlice = createSlice({
  name: "cmsMenus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMenus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMenus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.menus = action.payload;
      })
      .addCase(getMenus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdMenu = action.payload;
      })
      .addCase(createMenu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.menuName = action.payload.name;
        state.menuLocation = action.payload.location;
        state.menuIsActive = action.payload.isActive;
        state.menuItems = action.payload.items;
      })
      .addCase(getAMenu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedMenu = action.payload;
      })
      .addCase(updateAMenu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedMenu = action.payload;
      })
      .addCase(deleteAMenu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default cmsMenusSlice.reducer;

